@if (!isLoading()) {

  <app-tables
    [headerItems]="headerItems()"
    [rows]="tableRows()"
    [currentActions]="currentActions()"
    [emptyContentTitle]="
      isArabic()
        ? 'لا توجد أصناف فرعية مطابقة لمعايير البحث'
        : 'No sub-products found matching your criteria'
    "
    (actionTrigger)="onHandleAction($event)"
  />

  <!-- Pagination -->
  <app-pagination
    [itemsPerPage]="pageSize() || 25"
    [currentPage]="currentPage()"
    [getPageNumbers]="getPageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="total()"
    (previousPage)="previousPage()"
    (nextPage)="nextPage()"
    (goToPage)="goToPage($event)"
    (changePageNumber)="onPageSizeChange($event)"
    (pageSizeChange)="onPaginationSizeChange()">
  </app-pagination>

}

@if (confirmationModal() && confirmationModalContent()) {
<app-confirmation-dialog
  [error]="errorActivation()"
  (onSubmit)="onConfirm()"
  (onCancel)="onCancelConfirmationModal()"
  [title]="confirmationModalContent()!.title"
  [description]="confirmationModalContent()!.description"
  [confirmContent]="confirmationModalContent()!.confirmContent"
  [type]="dialogType()"
  [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
/>
}

@if (isSuccessNotification()) {

  <app-successful-notification
    type="success"
    [title]="
      isArabic()
        ? type() === 'deactivate-sub'
          ? 'تم إلغاء تفعيل الصنف الفرعي'
          : type() === 'delete-sub'
            ? 'تم حذف الصنف الفرعي'
            : 'تم تفعيل الصنف الفرعي'
        : type() === 'deactivate-sub'
          ? 'Sub-product deactivated successfully. The sub-product is now hidden from customers.'
          : type() === 'delete-sub'
            ? 'Sub-product deleted successfully.'
            : 'Sub-product activated successfully. The sub-product is now visible to customers.'
    "
  />

}